import config from '@config';

/** 경로 세그먼트만 안전 인코딩 (이중 인코딩 방지) */
export function encodePathnameSafely(pathname: string): string {
  return pathname
    .split('/')
    .map((seg) => {
      if (!seg) return seg;
      try {
        return encodeURIComponent(decodeURIComponent(seg));
      } catch {
        return encodeURIComponent(seg);
      }
    })
    .join('/');
}

/**
 * 무조건 ? → %3F, # → %23 치환
 * - URL 전체 문자열에서 처리 후, pathname 세그먼트만 추가 인코딩
 */
export function makeSafeUrl(rawUrl: string): string {
  if (!rawUrl) return rawUrl;

  // 1) 도메인 교체
  let replaced = rawUrl.replace(config.CLOUDFRONT_DISTRIBUTION_URL ?? '', config.CLOUDFRONT_ALTERNATE_URL ?? '');

  // 2) ?와 # 무조건 경로 기호로 인코딩
  //    단, 이미 %3F, %23로 인코딩된 경우는 이중 인코딩 방지
  replaced = replaced.replace(/\?/g, '%3F').replace(/#/g, '%23');

  // 3) URL 파싱
  let u: URL;
  try {
    u = new URL(replaced);
  } catch {
    u = new URL(replaced, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
  }

  // 4) pathname 세그먼트 안전 인코딩
  u.pathname = encodePathnameSafely(u.pathname);

  return u.toString();
}

export const downloadImage = async (imageUrl?: string, originFileName?: string): Promise<boolean> => {
  try {
    if (!imageUrl) {
      throw new Error('이미지 url이 존재하지 않음');
    }

    const replacedImageUrl = imageUrl.replace(
      config.CLOUDFRONT_DISTRIBUTION_URL ?? '',
      config.CLOUDFRONT_ALTERNATE_URL ?? ''
    );

    const safeImageUrl = makeSafeUrl(replacedImageUrl);

    const response = await fetch(safeImageUrl, {
      method: 'GET',
      credentials: 'include'
    });

    if (!response.ok) throw new Error('이미지 다운로드 실패');

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;

    // URL에서 확장자 추출
    const urlExtension = imageUrl.split('.').pop()?.split('?')[0].split('#')[0];

    // originFileName의 확장자를 URL의 확장자로 변경
    if (originFileName) {
      const fileNameWithoutExt = originFileName.replace(/\.[^/.]+$/, '');
      link.download = urlExtension ? `${fileNameWithoutExt}.${urlExtension}` : originFileName;
    } else {
      link.download = urlExtension ? `refa_image.${urlExtension}` : 'refa_image';
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('이미지 다운로드 실패:', error);
    return false;
  }
};
